import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {
  Dropdown,
  
  // Glyphicon
} from 'react-bootstrap'

import style from './style.css'
import base from '../../style/base.css'

export default function MobileNavDropdown (props) {
  const {
    isInstructor,
    locationTitle,
    cssModifier,
    onAboutLearningCurveClick,
    tipsForSuccess,
    openInsights
  } = props

  const aboutTitle = `About ${locationTitle}`
  const menuItems = isInstructor
    ? ([
    <Dropdown.Item
      className={style.mobileNavItem}
      eventKey="2"
      key="menu-item-2"
      onClick={props.onPreviewClick}
    >
      Preview as a Student
    </Dropdown.Item>,
    <Dropdown.Item
      className={style.mobileNavItem}
      eventKey="3"
      key="menu-item-3"
      onClick={onAboutLearningCurveClick}
    >
      {aboutTitle}
    </Dropdown.Item>
      ])
    : (
    <Dropdown.Item
      className={style.mobileNavItem}
      eventKey="2"
      key="menu-item-2"
      onClick={tipsForSuccess}
    >
      Tips for Success
    </Dropdown.Item>
      )

  const trendsInsightsText = isInstructor ? '' : 'My'
  const dropdownToggleCss = classnames(style.mobileNavDropdown, style[`mobileNavDropdown--${cssModifier}`])

  return (
    <Dropdown
      id="mobile-nav-dropdown"
      className={base.pullRight}
    >
      <Dropdown.Toggle className={dropdownToggleCss} noCaret>
        {/* <Glyphicon
          glyph="option-horizontal"
          className={style.mobileNavGlyph}
        /> */}
      </Dropdown.Toggle>
      <Dropdown.Menu className={style.mobileNavMenu}>
        <Dropdown.Item
          className={style.mobileNavItem}
          eventKey="1"
          key="menu-item-1"
          onClick={openInsights}
        >
          {trendsInsightsText} Trends & Insights
        </Dropdown.Item>
        {menuItems}
      </Dropdown.Menu>
    </Dropdown>
  )
}

MobileNavDropdown.propTypes = {
  openInsights: PropTypes.func.isRequired,
  isInstructor: PropTypes.bool,
  tipsForSuccess: PropTypes.func,
  onPreviewClick: PropTypes.func,
  onAboutLearningCurveClick: PropTypes.func,
  locationTitle: PropTypes.string,
  cssModifier: PropTypes.string
}

MobileNavDropdown.defaultProps = {
  cssModifier: 'Lite'
}
